module.exports = __webpack_public_path__ + "59acfddf84a7d43bbee670dd6a09d222.png";